module.exports = function negotiateLink(element, link) {

    if(link) {
        element.href = link;
        element.classList.add('has-link');
    } else {
        element.href = undefined;
        element.classList.remove('has-link');
    }
}
